import { useState, useEffect } from "react";
import { useAmiCommand } from "./use-ami-command";

interface LogSettings {
  debugLevel: number;
  verboseLevel: number;
  pjsipLoggerEnabled: boolean;
  setDebugLevel: (level: number) => void;
  setVerboseLevel: (level: number) => void;
  setPjsipLogger: (enabled: boolean) => void;
  isLoading: boolean;
}

export function useLogSettings(): LogSettings {
  const [debugLevel, setDebugLevel] = useState(0);
  const [verboseLevel, setVerboseLevel] = useState(0);
  const [pjsipLoggerEnabled, setPjsipLoggerEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const amiCommand = useAmiCommand();

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const resp = await fetch("/api/logs/settings");
      const data = await resp.json();
      setDebugLevel(data.debug_level ?? 0);
      setVerboseLevel(data.verbose_level ?? 0);
      setPjsipLoggerEnabled(data.pjsip_logger_enabled ?? false);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetDebug = (level: number) => {
    setDebugLevel(level);
    amiCommand.mutate(`core set debug ${level}`);
  };

  const handleSetVerbose = (level: number) => {
    setVerboseLevel(level);
    amiCommand.mutate(`core set verbose ${level}`);
  };

  const handleSetPjsipLogger = (enabled: boolean) => {
    setPjsipLoggerEnabled(enabled);
    amiCommand.mutate(`pjsip set logger ${enabled ? "on" : "off"}`);
  };

  return {
    debugLevel,
    verboseLevel,
    pjsipLoggerEnabled,
    setDebugLevel: handleSetDebug,
    setVerboseLevel: handleSetVerbose,
    setPjsipLogger: handleSetPjsipLogger,
    isLoading,
  };
}